import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Box } from 'grid-styled'
import { withRouter } from 'react-router-dom'
import { utils } from 'alelo-logic'

import Radio from '../../elements/Radio'
import TextInput from '../../elements/TextInput'

import { ParagraphGrayLabel } from '../../pages/BlockIdentifierNew/styles'

const renderRadio = ({ input, label }) => <Radio {...input} label={label} />

const renderOtherMotive = ({ placeholder, input, onChange, value, meta: { touched, error } }) => (
  <div>
    <ParagraphGrayLabel>QUAL O NÚMERO DA NOVA VELOETAG?</ParagraphGrayLabel>
    <TextInput
      {...input}
      placeholder={placeholder}
      maxlength="10"
      errorMessage={touched && error}
    />
  </div>
)

const BlockIdentifiersListOptions = props => {
  const { list, handleChange, optionSelected, handleChangeNewVeloeTag } = props

  return (
    <Box mt={15}>
      <form onSubmit={() => {}}>
        {list &&
          list.map(item => (
            <Box mb={10} key={item.chave}>
              <Field
                component={renderRadio}
                label={item.descricao}
                name="option"
                value={item.chave}
                type="radio"
                onChange={e => handleChange(e)}
              />
            </Box>
          ))}
        {optionSelected === 'POSSUO' && (
          <Box mb={20}>
            <Field
              component={renderOtherMotive}
              placeholder="Digite aqui"
              name="novoCodigoIdentificador"
              onChange={e => handleChangeNewVeloeTag(e)}
              validate={utils.identifierValidate}
            />
          </Box>
        )}
      </form>
    </Box>
  )
}

export default reduxForm({
  form: 'formBlockIdentifierListOptions',
  destroyOnUnmount: true
})(withRouter(BlockIdentifiersListOptions))



// WEBPACK FOOTER //
// ./src/app/modules/BlockIdentifiersListOptions/index.js